import { CSSProperties, memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Tippy from '@tippyjs/react/headless';
import classNames from 'classnames/bind';
import { ReactComponent as Geocloud } from '~/assets/svg/geocloud_logo.svg';
import styles from './SwitcherLng.module.scss';
import rotateChevron from '~/layouts/components/Header/utils/rotateChevron';
import styled from 'styled-components';

import { MdChevronRight } from 'react-icons/md'

interface SwitcherLngPropsType {
  style?: CSSProperties;
}

const Languages = [
  { lng: 'English', code: 'en' },
  // { lng: "中文", code: "cn" },
  // { lng: "Français", code: "fr" },
  // { lng: "Bahasa Indonesia", code: "id" },
  // { lng: "Português", code: "pt" },
  // { lng: "Español", code: "es" },
  { lng: 'Việt Nam', code: 'vn' },
];
const cx = classNames.bind(styles);

const SwitcherLng: React.FC<SwitcherLngPropsType> = ({ style }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    // <Tippy
    //   trigger="click"
    //   interactive
    //   offset={[0, 10]}
    //   placement="bottom"
    //   delay={0}
    //   render={(attrs) => (
    //     <UI_OptionWrapper {...attrs}>
    //       <UI_OptionItem
    //       >
    //         <span>{t('File')}</span>
    //         <MdChevronRight />
    //       </UI_OptionItem>
    //       <UI_OptionItem
    //       >
    //         <span>{t('Edit')}</span>
    //       </UI_OptionItem>
    //       <UI_OptionItem
    //       >
    //         <span>{t('View')}</span>
    //       </UI_OptionItem>
    //     </UI_OptionWrapper>
    //   )}
    // >
    <UI_ContentWrapper onClick={handleLogoClick}>
      <Geocloud style={{ width: 50, height: 50 }} />
      <span> Geocloud </span>
    </UI_ContentWrapper>
    // </Tippy>
  );
};

export default memo(SwitcherLng);
const UI_ContentWrapper = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  font-size: 18px;
  font-weight: 1000;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  span {
    @media (max-width: 768px) {
      display: none;
    }
  }

  i {
    @media (max-width: 768px) {
      display: none;
    }
  }
`
const UI_OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 5px 0;
  min-width: 100px;
`
const UI_OptionItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  cursor: pointer;
  transition: 0.3s;
  font-size: 14px;
  &:hover {
    background-color: var(--color-primary);
    color: white;
  }
  &.active {
    background-color: var(--color-primary);
    color: white;
  }
`